"use client";

import { WhyChooseUsSection } from "@/components/sections/why-choose-us";
import { whyChooseUs } from "@/lib/data/services-competitive-intelligence";

export function WhyChooseUs() {
  return (
    <WhyChooseUsSection
      eyebrow={whyChooseUs.eyebrow}
      title={whyChooseUs.title}
      accent={whyChooseUs.accent}
      gridCols={whyChooseUs.gridCols}
      reasons={whyChooseUs.reasons}
    />
  );
}